import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Col, Form, Row, Select } from 'antd';
import { PercelenModel } from 'pages/bodem-en-gewas/percelen-old/models/percelenMock';
import { FC } from 'react';
import { CustomInputNumber } from '../../../../../components/Form/CustomInputNumber';
import styles from '../../styles.module.scss';
interface GewasRowProps {
  type: {
    title: string;
    formKey: string;
  };
  isKlwReadOnly: boolean;
  remove: (index: number) => void;
  index: number;
}
export const GewasRow: FC<GewasRowProps> = ({ type, remove, index, isKlwReadOnly }) => {
  return (
    <Form.Item
      noStyle
      shouldUpdate={(prev, cur) => {
        return (
          prev.bouwlandenTeeltTypesGrondgebruikTypes !== cur.bouwlandenTeeltTypesGrondgebruikTypes ||
          prev.voorNaTeeltVanggewassen[type.formKey][index]?.teeltTypeId !== cur.voorNaTeeltVanggewassen[type.formKey][index]?.teeltTypeId ||
          prev.voorNaTeeltVanggewassen[type.formKey][0]?.isOpgegeven !== cur.voorNaTeeltVanggewassen[type.formKey][0]?.isOpgegeven
        );
      }}>
      {({ getFieldValue, setFields }) => {
        const currentSelectedTeeltype: number = getFieldValue(['voorNaTeeltVanggewassen', type.formKey, index, 'teeltTypeId']);
        const bouwlandenTeeltTypesGrondgebruikTypes: PercelenModel['bouwlandenTeeltTypesGrondgebruikTypes'] = getFieldValue([
          'bouwlandenTeeltTypesGrondgebruikTypes',
        ]);
        const bouwlandenTeeltTypesGrondgebruikType = bouwlandenTeeltTypesGrondgebruikTypes?.find(bouwlandenTeeltTypesGrondgebruikType =>
          bouwlandenTeeltTypesGrondgebruikType?.bouwlandCategorie?.omschrijving.toLowerCase().includes(type.formKey.toLowerCase())
        );
        let grondgebruikTypes: {
          grondgebruikTypeId: number;
          code: string;
          omschrijving: string;
        }[] = [];
        let teeltTypes: {
          teeltTypeId: number;
          code: string;
          omschrijving: string;
          heeftGrondgebruikTypes: boolean;
        }[] = [];
        if (bouwlandenTeeltTypesGrondgebruikType) {
          teeltTypes = bouwlandenTeeltTypesGrondgebruikType?.teeltTypes;
          if (
            currentSelectedTeeltype &&
            bouwlandenTeeltTypesGrondgebruikType?.teeltTypes.find(tt => tt.teeltTypeId === currentSelectedTeeltype)?.heeftGrondgebruikTypes
          ) {
            grondgebruikTypes = bouwlandenTeeltTypesGrondgebruikType?.grondgebruikTypes;
          }
        }

        const isAkkerbouw = type.title === 'Akkerbouw';
        const isOpgegeven = getFieldValue(['voorNaTeeltVanggewassen', type.formKey, 0, 'isOpgegeven']);
        let isVoorNagewas = false;
        if (currentSelectedTeeltype) {
          isVoorNagewas =
            currentSelectedTeeltype === 3 || //Voorgewas
            currentSelectedTeeltype === 4; //Nagewas;

          if (!isVoorNagewas) {
            const fields = getFieldValue(['voorNaTeeltVanggewassen', type.formKey, index]);

            if (fields.opbrengstInKgDsPerHa || fields.gehalteN || fields.gehalteP || fields.vem || fields.grondgebruikTypeId || fields.gewasGroepId) {
              setFields([
                {
                  name: ['voorNaTeeltVanggewassen', type.formKey, index, `opbrengstInKgDsPerHa`],
                  value: undefined,
                },
                {
                  name: ['voorNaTeeltVanggewassen', type.formKey, index, `gehalteN`],
                  value: undefined,
                },
                {
                  name: ['voorNaTeeltVanggewassen', type.formKey, index, `gehalteP`],
                  value: undefined,
                },
                {
                  name: ['voorNaTeeltVanggewassen', type.formKey, index, `vem`],
                  value: undefined,
                },
                {
                  name: ['voorNaTeeltVanggewassen', type.formKey, index, `grondgebruikTypeId`],
                  value: undefined,
                },
                {
                  name: ['voorNaTeeltVanggewassen', type.formKey, index, `gewasGroepId`],
                  value: undefined,
                },
              ]);
            }
          }
        }

        return (
          <Row gutter={12}>
            <Col span={5}>
              <Form.Item name={[index, `teeltTypeId`]}>
                <Select
                  disabled={isKlwReadOnly}
                  showSearch={{
                    filterOption: (input, option) =>
                      String(option?.label ?? '')
                        .toLowerCase()
                        .includes(input.toLowerCase()),
                  }}
                  style={{ fontSize: 12 }}
                  styles={{ popup: { root: { minWidth: 950 } } }}
                  options={teeltTypes.map(teelttype => ({ value: teelttype?.teeltTypeId, label: teelttype?.omschrijving }))}
                />
              </Form.Item>
            </Col>
            <Col span={3}>
              <Form.Item name={[index, `grondgebruikTypeId`]}>
                <Select
                  showSearch={{
                    filterOption: (input, option) =>
                      String(option?.label ?? '')
                        .toLowerCase()
                        .includes(input.toLowerCase()),
                  }}
                  style={{ fontSize: 12 }}
                  className="text-left"
                  styles={{ popup: { root: { minWidth: 950 } } }}
                  disabled={!grondgebruikTypes.length || isKlwReadOnly}
                  options={grondgebruikTypes.map(grondgebruikType => ({
                    value: grondgebruikType.grondgebruikTypeId,
                    label: grondgebruikType.omschrijving,
                  }))}
                />
              </Form.Item>
            </Col>
            <Col span={isAkkerbouw ? 0 : 7}>
              <Form.Item
                noStyle
                shouldUpdate={(prev, cur) => {
                  return (
                    prev.voorNaTeeltVanggewassen[type.formKey][index]?.grondgebruikTypeId !==
                    cur.voorNaTeeltVanggewassen[type.formKey][index]?.grondgebruikTypeId
                  );
                }}>
                {({ getFieldValue, setFields }) => {
                  const gewasgroepen: PercelenModel['gewasgroepen'] = getFieldValue(['gewasgroepen']);
                  const grondgebruikTypeId: number = getFieldValue(['voorNaTeeltVanggewassen', type.formKey, index, 'grondgebruikTypeId']);
                  const isCropAkkerbouw = grondgebruikTypes.find(type => type.grondgebruikTypeId === grondgebruikTypeId)?.code === 'AKKERBOUW';

                  const currentGewasGroepValue: number = getFieldValue(['voorNaTeeltVanggewassen', type.formKey, index, `gewasGroepId`]);
                  const disabled = !isCropAkkerbouw && currentGewasGroepValue !== undefined;
                  if (disabled) {
                    setFields([
                      {
                        name: ['voorNaTeeltVanggewassen', type.formKey, index, `gewasGroepId`],
                        value: undefined,
                      },
                    ]);
                  }
                  return !isAkkerbouw ? (
                    <Form.Item
                      rules={[
                        {
                          required: isCropAkkerbouw,
                          message: '',
                        },
                      ]}
                      className={styles.noEmptyMessageWhitespace}
                      name={[index, `gewasGroepId`]}>
                      <Select
                        disabled={isKlwReadOnly || !gewasgroepen || !isCropAkkerbouw}
                        showSearch={{
                          filterOption: (input, option) =>
                            String(option?.label ?? '')
                              .toLowerCase()
                              .includes(input.toLowerCase()),
                        }}
                        className="text-left"
                        style={{ fontSize: 12, width: '100%' }}
                        styles={{ popup: { root: { minWidth: 1200 } } }}
                        options={gewasgroepen?.map(gewasGroep => ({ value: gewasGroep.gewasGroepId, label: gewasGroep.omschrijving }))}
                      />
                    </Form.Item>
                  ) : null;
                }}
              </Form.Item>
            </Col>
            <Col span={2} className="text-right">
              <Form.Item name={[index, `oppervlakteInHa`]}>
                <CustomInputNumber disabled={isKlwReadOnly} min={0} max={500} precision={2} />
              </Form.Item>
            </Col>
            {isOpgegeven && (
              <>
                <Col span={1} className="text-right">
                  <Form.Item name={[index, `opbrengstInKgDsPerHa`]}>
                    <CustomInputNumber disabled={isKlwReadOnly || !isVoorNagewas} min={0} max={1_000_000} />
                  </Form.Item>
                </Col>
                <Col span={2} className="text-right">
                  <Form.Item name={[index, `gehalteN`]}>
                    <CustomInputNumber disabled={isKlwReadOnly || !isVoorNagewas} max={500} min={0} precision={2} />
                  </Form.Item>
                </Col>
                <Col span={1} className="text-right">
                  <Form.Item name={[index, `gehalteP`]}>
                    <CustomInputNumber disabled={isKlwReadOnly || !isVoorNagewas} max={100} min={0} precision={2} />
                  </Form.Item>
                </Col>
                <Col span={2} className="text-right">
                  <Form.Item name={[index, `vem`]}>
                    <CustomInputNumber disabled={isKlwReadOnly || !isVoorNagewas} max={1500} min={0} />
                  </Form.Item>
                </Col>
              </>
            )}
            <Col span={1}>
              <Button type="text" style={{ color: 'rgba(0,0,0,.85)' }} onClick={() => remove(index)}>
                <FontAwesomeIcon icon="trash" />
              </Button>
            </Col>
          </Row>
        );
      }}
    </Form.Item>
  );
};
